import { types } from "../action-types";

const initialState = {
  loading: false,
  candidateDetails: {},
  error: false,
  candidateHeader: false,
  headerKey:32,
  searchFlag: false,
};

const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CANDIDATE_DETAILS_INIT:
      return {
        ...state,
        loading: true,
        candidateDetails: {},
        candidateHeader: !state.candidateHeader,
        headerKey:Math.random() *100
      };
      
      case types.CANDIDATE_DETAILS_SUCCESS:
        return {
          ...state,
          loading: false,
          candidateDetails: action.payload,
          error: false,
          candidateHeader: false,
          headerKey:Math.random() *100
        };
        case types.CANDIDATE_DETAILS_FAILURE:
          return {
            ...state,
            loading: false,
            candidateDetails: {},
            error: true,
            candidateHeader: false,
            headerKey:Math.random()*100
      };
      case types.RESET_HEADER_STATE:
        return{
          ...state,
          headerKey:Math.random()*100
        }
        case types.TOGGLE_SEARCH_TRUE:
          return {
            ...state,
            searchFlag: true
          };
    
        case types.TOGGLE_SEARCH_FALSE:
          return {
            ...state,
            searchFlag: false
          };
    default:
      return state;
  }
};

export default candidateReducer;
